<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  ><path
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.75"
    d="M6.13 6.129A8.807 8.807 0 1 1 3.889 12v-.927"
  /><path
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.75"
    d="m6.206 13.854-2.318-2.781-2.318 2.781M15.815 9.185l-3.277 3.278"
  />
  </svg>
</template>
